import React from "react";
import { useMediaQuery } from "@chakra-ui/react";

interface HiddenProps {
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
}

export const Hidden: React.FC<HiddenProps> = ({
  sm = false,
  md = false,
  lg = false,
  xl = false,
  children,
}) => {
  const [isBase, isSm, isMd, isLg, isXl] = useMediaQuery([
    "(max-width: 600px)",
    "(min-width: 600px)",
    "(min-width: 960px)",
    "(min-width: 1440px)",
    "(min-width: 1920px)",
  ]);

  if (isXl) {
    if (xl) {
      return null;
    }
    return <>{children}</>;
  }

  if (isLg) {
    if (lg) {
      return null;
    }
    return <>{children}</>;
  }

  if (isMd) {
    if (md) {
      return null;
    }
    return <>{children}</>;
  }

  if (isSm) {
    if (sm) {
      return null;
    }
    return <>{children}</>;
  }

  if (isBase) {
    if (sm) {
      return null;
    }
    return <>{children}</>;
  }

  return <>{children}</>;
};
